function Form_element_form_list_editor(element) {
  this.$element = $(element);

  this.data = {
    type: 'type',
    formElementID: 'form-element-id',
    formID: 'form-id',
    imageDelete: 'image-delete',
    imageMove: 'image-move'
  };

  this.init = function() {
    this.dataType = this.$element.data(this.data.type);
    this.dataFormElementID = this.$element.data(this.data.formElementID);
    this.dataFormID = this.$element.data(this.data.formID);
    this.dataImageDelete = this.$element.data(this.data.imageDelete);
    this.dataImageMove = this.$element.data(this.data.imageMove);

    this.initListEditor();
  };

  this.initListEditor = function() {
    i4_List_editor.get('form_multiple_list').
    set_element_result_id('list_edit_select_result').
    set_ajax_parameter({
        js: 'form_element',
        call: 'list_edit',
        type: this.dataType,
        form_element_id: this.dataFormElementID,
        form_id: this.dataFormID
    }).
    set_option({
      image_delete: this.dataImageDelete,
      image_move: this.dataImageMove
    }).
    run();
  };
}
